import React from 'react';
import Carousel from './Carousel';
import HowRentTwo from '../pages/HowRentTwo';
import BookingCarOne from '../pages/BookingCarOne';
import YourDreamOne from '../pages/YourDreamOne';
import ExploreOurCars from '../pages/ExploreOurCars';
import LuxuryCarOne from '../pages/LuxuryCarOne';
import AskedQuestion from '../pages/AskedQuestion';
import FleetCTA from '../pages/FleetCTA';
import TestimonialsOne from '../pages/TestimonialsOne';
import CtaTwo from '../pages/CtaTwo';
import BlogSix from '../pages/BlogSix';





const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
<HowRentTwo/>
<BookingCarOne/>
<YourDreamOne/>
<ExploreOurCars/>
<LuxuryCarOne/>
{/* <AskedQuestion/> */}
<FleetCTA/>
<TestimonialsOne/>
<CtaTwo/>
<BlogSix/>
    </div>
  );
};

export default HeroSection;
